import { PARAM } from '@/constants'
import { getDataFromUrl } from '@/helpers'

export function getRegionIdFromQuery(
  query?: URLSearchParams | undefined
): number | undefined {
  const id = query?.get(PARAM.REGION)
  if (id == null) return undefined
  const idn = Number(id)
  if (isNaN(idn)) return undefined
  return idn
}

export function getRegionIdFromSegment(segment?: string): number | undefined {
  const { id } = getDataFromUrl(segment)
  if (id == null) return undefined
  const idn = Number(id)
  if (isNaN(idn)) return undefined
  return idn
}
